import View from './View';
import CardSchema from './schema';
import icon from '@plone/volto/icons/cards.svg';

const CardBlock = {
  id: 'w_card',
  title: 'Card',
  view: View,
  icon: icon,
  group: 'wildcard',
  restricted: false,
  mostUsed: false,
  sidebarTab: 1,
  blockSchema: CardSchema,
};

export default CardBlock;